module.exports = __webpack_public_path__ + "img/gb862_1.prt.89067cc2.jpg";